import {
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'

// action types
const ADD_SETTINGS = 'rp/settings/ADD_SETTINGS'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case ADD_SETTINGS:
      return {
        ...state,
        ...payload,
      }
    case CHANGE_USER_ACCOUNT:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
// payload = { [key]: any }
export const addSettings = payload => ({
  type: ADD_SETTINGS,
  payload,
})
